var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriceRemoved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3046 10.3516L10.1484 2.19536C10.0759 2.12275 9.9867 2.0691 9.8886 2.03912C9.7905 2.00915 9.68653 2.00378 9.58587 2.02349L3.28118 3.2813L2.02337 9.58599C2.00366 9.68665 2.00902 9.79062 2.039 9.88872C2.06897 9.98682 2.12263 10.076 2.19524 10.1485L6.01848 13.9717",
    stroke: "#EE4444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 7.5C7.08027 7.5 7.5 7.08027 7.5 6.5625C7.5 6.04473 7.08027 5.625 6.5625 5.625C6.04473 5.625 5.625 6.04473 5.625 6.5625C5.625 7.08027 6.04473 7.5 6.5625 7.5Z",
    fill: "#EE4444"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69141 16.9703V12.8997L10.8705 16.9703V12.8997M14.7117 12.8997H12.8759V14.935M12.8759 16.9703V14.935M12.8759 14.935H14.5523M16.5019 12.8997H17.6164M17.6164 12.8997H18.7097M17.6164 12.8997V16.9703",
    stroke: "#EE4444",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceRemoved);
export default __webpack_public_path__ + "static/media/price-removed.7a946afdf0bf17756072f3ccb71b7d2a.svg";
export { ForwardRef as ReactComponent };